import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number) => {
  var oTable = $("#example").dataTable();
  window.$settings_werkregels_Glist = [];
  window.$settings_werkregels_base_Glist = result.data[0];
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (result.data[0].data.aliases.length > 0) {
    $.each(result.data[0].data.aliases, function (index, data) {
      var circleType = "";
      var visible =
        data["visible"] === true
          ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
          : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';

      var checkbox =
        '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

      var fieldName =
        '<span class="text-dark font-weight-bold">' +
        data["field_name"] +
        "</span>";

      var alias = data["alias"];
      if (typeof alias === "undefined") {
        alias = "";
      }

      var model = {
        visible: data["visible"],
        fieldName: data["field_name"],
        alias: alias,
      };
      // that.Glist.push(model);
      window.$settings_werkregels_Glist.push(model);
      var addId = oTable.fnAddData(
        [checkbox, circleType, fieldName, alias, visible],
        false
      );

      var theNode = $("#example").dataTable().fnSettings().aoData[addId[0]].nTr;
      theNode.setAttribute("rowId", data["field_name"]);
    });
    oTable.fnDraw();
  } else {
    $("tbody").html();
    oTable.fnClearTable();
  }
  $("#cover-spin").hide(0);
  // $("#total-rows").html(result.meta.total_found);
  // window.$settings_werkregels_table_total_row_count = result.meta.total_found;
  window.$settings_werkregels_treeChangeStatus = true;
  window.$settings_werkregels_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$settings_werkregels_algemeenCode.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-code") {
    window.$settings_werkregels_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$settings_werkregels_algemeenCode.push(data);
    });
  }
  if (searchId === "algemeen-naam") {
    window.$settings_werkregels_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$settings_werkregels_algemeenNaam.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {
  Common.sleep(1000).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Beheereenheid zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    Common.StartActivity(
      model,
      [window.$settings_werkregels_newInsertId],
      "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
      beheereenheidSavedNext(token),
      token
    );
  });
};
function beheereenheidSavedNext(token) {
  Common.sleep(5000).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$settings_werkregels_refresh();
    /*omnimap
      .FillTableAction(
        window.$settings_werkregels_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = () => {
  Common.sleep(1500).then(() => {
    window.$settings_werkregels_refresh();
    /*omnimap
      .GetFreeFormatByIdAction(process.env.REACT_APP_SETTING_WERKREGELS)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$settings_werkregels_refresh();
    /*omnimap
      .FillTableAction(
        window.$settings_werkregels_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = async (result) => {
  // var actionsOfSelection = [];
  // var actionsOfDisabled = [];
  // var BreakException = {};
  // $.each(result.data.stages, function (index, stage) {
  //   if (stage.definition.type === "activity" && stage.start_allowed === true) {
  //     actionsOfSelection.push(stage.definition.identification);
  //   } else {
  //     actionsOfDisabled.push(stage.definition);
  //   }
  // });
  // $("#myPopup").html("");
  // $.each(window.$settings_werkregels_actions, function (index, action) {
  //   if ($.inArray(action["id"], actionsOfSelection) !== -1) {
  //     var anchor = $("<a></a>")
  //       .attr({ href: "javascript:void(0)", id: action["id"] })
  //       .addClass(action["class"] + " catalog-action")
  //       .html(action["text"]);
  //     $("#myPopup").append(anchor);
  //   }
  // });
  // //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });
  // var isDelete = true;
  // if (result.data.stages.length > 0) {
  //   let arr = window.$settings_werkregels_selectedIds;
  //   for (let i = 0; i < arr.length; i++) {
  //     let getRowOfDetail = await omnimap.GetRowOfDetailAction(
  //       arr[i],
  //       window.$settings_werkregels_token
  //     );
  //     if (
  //       getRowOfDetail.data.delete_allowed &&
  //       getRowOfDetail.data.delete_allowed !== undefined
  //     ) {
  //       // var verwijderen = $("<a></a>")
  //       //   .attr({ href: "javascript:void(0)", id: "verwijderen" })
  //       //   .addClass("trash-bin beheereenheid")
  //       //   .html("Verwijderen");
  //       // $("#myPopup").append(verwijderen);
  //       // break;
  //       isDelete = true;
  //     } else {
  //       // var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
  //       //   .attr({ href: "javascript:void(0)", id: "" })
  //       //   .addClass("trash-bin beheereenheid")
  //       //   .html("Verwijderen");
  //       // verwijderen.append(
  //       //   `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
  //       // );
  //       // $("#myPopup").append(verwijderen);
  //       // break;
  //       isDelete = false;
  //       break;
  //     }
  //   }
  //   if (isDelete) {
  //     var verwijderen = $("<a></a>")
  //       .attr({ href: "javascript:void(0)", id: "verwijderen" })
  //       .addClass("trash-bin beheereenheid")
  //       .html("Verwijderen");
  //     $("#myPopup").append(verwijderen);
  //   } else {
  //     var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
  //       .attr({ href: "javascript:void(0)", id: "" })
  //       .addClass("trash-bin beheereenheid")
  //       .html("Verwijderen");
  //     verwijderen.append(
  //       `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
  //     );
  //     $("#myPopup").append(verwijderen);
  //   }
  // } else {
  //   var beheereenheidToevoegen = $("<a></a>")
  //     .attr({ href: "javascript:void(0)", id: "beheereenheid_toevoegen" })
  //     .addClass("maatregelen beheereenheid")
  //     .html("Werkregel toevoegen");
  //   $("#myPopup").append(beheereenheidToevoegen);
  // }
  // var popup = document.getElementById("myPopup");
  // popup.classList.toggle("show");
};
